import { createSelector } from "@ngrx/store";

import * as fromFeature from "../reducers";
import * as fromCourseMetrics from "../reducers/course-metrics.reducer";

// Now, one level down from 'assignmentsModule' in our state tree
// Assignments state
// In createSelector, we essential build the path to the state we want
// getStudentCoursesModuleState = top level of state tree: assignmentsModule
export const getCourseMetricsState = createSelector(
    fromFeature.getStudentCoursesModuleState,
    (state: fromFeature.StudentCoursesState) => state.courseMetrics
);

// these select individual properties on a Assignment State (data, loading, loaded)
// using the entities, this returns a data object (used for high-performance reading, updating & removing)
export const getCourseMetrics = createSelector(
    getCourseMetricsState,
    fromCourseMetrics.getCourseMetrics
);
